var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-wrapper"},[_c('label',{attrs:{"for":"filtro"},domProps:{"textContent":_vm._s(_vm.$t('filtrar-por'))}}),_c('SelectBox',{attrs:{"items":_vm.options,"placeholder":'',"icons":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }